import { useEffect } from 'react';
import hotKeyConverter, { KeyType } from '../utility/keyCodeConverter';

const useHotkey = (key: keyof KeyType, callback: () => void) => {

  useEffect(() => {
    const hotKeyHandler = (event: KeyboardEvent) => {
      if (event.keyCode === hotKeyConverter(key)) {
        event.preventDefault();
        callback();
      }
    };
    window.addEventListener('keydown', hotKeyHandler);
    return () => {
      window.removeEventListener('keydown', hotKeyHandler);
    };
  }, [callback, key]);
};

export default useHotkey;
